import linkStrategy from './linkStrategy.js';
import link from '../../components/Link/index.js';

('use strict');
Object.defineProperty(exports, '__esModule', {
  value: true,
});
var _linkStrategy = _interopRequireDefault(linkStrategy);
var _Link = _interopRequireDefault(link);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var createLinkDecorator = function createLinkDecorator(config, store) {
  return {
    strategy: (0, _linkStrategy.default)(config, store),
    component: _Link.default,
  };
};
var _default = createLinkDecorator;
export default _default;
